export default __webpack_public_path__ + "static/media/Group 162.ad0a80e5.png";